import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
  loading: false,
  error: null,
  data: null,
  
};

// export const CreateFestivalData = createAsyncThunk(
//   "CreateFestivalData",
//   async (body) => {
//     try {
//       const response = await instance.post("/crm/holidays/add-holidays", body);

//       return response?.data;
//     } catch (error) {
//       return error;
//     }
//   }
// );

export const GetFestivalData = createAsyncThunk(
  "GetFestivalData",
  async (body) => {
    try {
      const response = await instance.get(
        `/crm/holidays/get-holidays-list?page=${body.page}&search=${body.search}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const FestivalSlice = createSlice({
  name: "FestivalSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(CreateFestivalData.pending, (state) => {
    //   state.response = null;
    //   state.loading = true;
    // });
    // builder.addCase(CreateFestivalData.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.data = action.payload;
    // });
    // builder.addCase(CreateFestivalData.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error;
    // });
    builder.addCase(GetFestivalData.pending, (state) => {
      state.data = null;
      state.loading = true;
    });
    builder.addCase(GetFestivalData.fulfilled, (state, action) => {
      state.loading = false;
     state.data = action.payload?.data;
    });
    builder.addCase(GetFestivalData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default FestivalSlice.reducer;
